// extracted by css-extract-rspack-plugin
export default {"citiesListContainer":"citiesListContainer-OBN3JO","citiesListTitle":"citiesListTitle-CDq6Ez"};